import { useEffect, useRef } from 'react';
import useLandingStore from '../v2-pages/admin-landing/store/useLandingStore';
import useSearchStore from '../v2-components/Search/store/useSearchStore';
import { useAdminCarouselStore } from '../v2-pages/admin-carousel/store/useCarouselStore';
import { useCarouselPharmacyStore } from '../v2-pages/carousel/store/useCarouselPharmacyStore';

export default function useClearSessionStorageOnPathChange() {
	const previousPathRef = useRef(window.location.pathname);
	const [resetLandingStore] = useLandingStore((state) => [state.resetLandingStore]);
	const [setProducts] = useSearchStore((state) => [state.setProducts]);
	const [resetCarouselStore] = useAdminCarouselStore((state) => [state.resetCarouselStore]);
	const [resetCarouselPharmacyStore] = useCarouselPharmacyStore((state) => [state.resetCarouselPharmacyStore]);

	useEffect(() => {
		const handlePathChange = () => {
			const currentPath = window.location.pathname;
			const basePath = currentPath.split('/')[1];
			const previousPath = previousPathRef.current;
			const previousBasePath = previousPath.split('/')[1];

			if (basePath !== previousBasePath) {
				resetLandingStore();
				resetCarouselStore();
				resetCarouselPharmacyStore();
				setProducts([]);
			}

			previousPathRef.current = currentPath;
		};

		window.addEventListener('popstate', handlePathChange);
		const originalPushState = window.history.pushState;
		const originalReplaceState = window.history.replaceState;

		window.history.pushState = function (...args) {
			originalPushState.apply(this, args);
			handlePathChange();
		};

		window.history.replaceState = function (...args) {
			originalReplaceState.apply(this, args);
			handlePathChange();
		};

		handlePathChange();

		return () => {
			window.removeEventListener('popstate', handlePathChange);
			window.history.pushState = originalPushState;
			window.history.replaceState = originalReplaceState;
		};
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [resetLandingStore, setProducts, resetCarouselStore]);
}
